import Request from 'redux/config/services/Request'
import axios from 'axios'
import { getPlatformType } from 'shared/Router/Utils'

type AttachmentType = 'image' | 'pdf'

const attachmentBasePath = (): string =>
  getPlatformType() === 'employee'
    ? '/ai_concierge/employee'
    : '/ai_concierge/admin'

export const getPresignedUrl = async (
  fileName: string,
  attachmentType: AttachmentType
) => {
  const response = await Request.post(
    `${attachmentBasePath()}/chat-attachments/upload/`,
    {
      attachmentType,
      fileName,
    }
  )
  return response
}

export const uploadFileToS3 = async (url: string, file: File) => {
  const response = await axios.put(url, file, {
    headers: {
      'Content-Type': 'application/octet-stream',
    },
    withCredentials: false,
    maxBodyLength: Infinity,
    maxContentLength: Infinity,
    transformRequest: [(data) => data],
  })
  return response
}

export const getDownloadUrl = async (
  fileName: string,
  attachmentType: AttachmentType
) => {
  const response = await Request.post(
    `${attachmentBasePath()}/chat-attachments/download/`,
    {
      attachmentType,
      fileName,
    }
  )
  return response
}
